import { render, staticRenderFns } from "./RaceCardSummary.vue?vue&type=template&id=b752430c&scoped=true"
import script from "./RaceCardSummary.vue?vue&type=script&lang=js"
export * from "./RaceCardSummary.vue?vue&type=script&lang=js"
import style0 from "./RaceCardSummary.vue?vue&type=style&index=0&id=b752430c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b752430c",
  null
  
)

export default component.exports